export const BASE_ROUTE = `${process.env.PUBLIC_URL}`;
export const NOTIFICATIONS_WINDOW_ROUTE = `notifications`;
export const COMMUNICATION_LOGS_WINDOW_ROUTE = `communication-logs`;
